/* ─── ProjectHub instellingen ────────────────────────────────────────────── */
/* Centrale plek voor instellingen die je soms wilt aanpassen.
   Sites toevoegen? Alleen dit bestand wijzigen, de rest blijft onaangetast. */

export const COLORS = ["#0078D4","#107C10","#CA5010","#8764B8","#008272","#D13438","#0063B1","#7A7574","#00B7C3","#E3008C"];
export const SP_SITES = [
  { label: "Offertes", hostname: "aannemersbedrijfbout.sharepoint.com", sitePath: "/sites/Offertes" },
  { label: "Projecten", hostname: "aannemersbedrijfbout.sharepoint.com", sitePath: "/sites/Projecten" },
];

// Minimale breedte per paneel in pixels
export const MIN_PANEL_PX = 200;

// Planner staat maximaal 20 items per checklist toe
export const MAX_CHECKLIST_ITEMS = 20;
